module.exports = __webpack_public_path__ + "img/wg-pcchd.85347105.png";